<script>
import Icon from "@/components/atoms/icon";
import Button from "@/components/atoms/button";
import { newlineToBr } from "@/utils/text-transformation";
import { uppercaseFirstLetter } from "@/composables/text-transformation";
import { isMagasinOpened, hasMagasinHoraires } from "@/utils/magasin";

export default {
  name: "MagasinOverview",
  components: { Icon, Button },
  props: {
    magasin: {
      type: Object,
      required: true
    },
    canChange: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  emits: ["change"],
  computed: {
    horairesFormatted() {
      return uppercaseFirstLetter(
        newlineToBr(this.magasin.attributes.horaires)
      );
    },
    isOpened() {
      return isMagasinOpened(this.magasin);
    },
    showIfOpened() {
      return hasMagasinHoraires(this.magasin);
    }
  }
};
</script>

<template>
  <div>
    <div class="u-flex">
      <Icon
        name="shop"
        size="sm"
        variant="primary"
      />
      <div class="u-pl-sm">
        <div class="u-flex u-flex-align-center u-mb-md">
          <p class="u-font-700 u-font-19 u-font-secondary u-pr-sm">
            Mon magasin
          </p>
          <Button
            v-if="canChange"
            link
            variant="text-light"
            @click="$emit('change')"
          >
            Changer
          </Button>
        </div>
        <div>
          <p class="u-mb-sm u-font-15 u-font-500">
            {{ magasin.attributes.magasin }}
          </p>
          <p>
            {{ magasin.attributes.adresse }}
          </p>
          <p>
            {{ magasin.attributes.cp }} {{ magasin.attributes.ville }}
          </p>
          <p class="u-mb-sm">
            {{ magasin.attributes.telephone_magasin }}
          </p>
          <template v-if="showIfOpened">
            <p
              v-if="isOpened"
              class="u-color-success"
            >
              Actuellement ouvert
            </p>
            <p
              v-else
              class="u-color-alert"
            >
              Actuellement fermé
            </p>
          </template>
          <p v-html="horairesFormatted" />
        </div>
      </div>
    </div>
    <div class="u-text-center u-mt-md">
      <Button
        variant="primary"
        radius="full"
        size="sm"
        :to="`/magasins/${magasin.attributes.aliasWeb}-m-${magasin.id}`"
      >
        Accéder à la page du magasin
      </Button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
